import React, {useEffect, useContext} from 'react';

import RecomendedResourcesList from '../../components/modules/RecomendedResourcesList';

import {errorStatusContext} from '../../contexts/ErrorStatusContext';
import {fetchApi, PAGE_SIZE} from '../../utils/ApiHelper';
import {loadingPauseContext} from '../../contexts/LoadingPauseContext';
import {HTTP_METHODS, RESOURCES} from '../../utils/URLConstants';
import {DLog} from '../../utils/HelperMethods';

export default function SuggestResources({title, isSeeAll}) {
  const [recommendedResources, setRecommendedResources] = React.useState([]);

  const esc = useContext(errorStatusContext);
  const lpc = useContext(loadingPauseContext);

  useEffect(() => {
    getRecommendedResources();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- mount-only data fetch; getRecommendedResources is re-created each render
  }, []);

  const getRecommendedResources = () => {
    const params = {
      type: 'all',
      pageNo: 1,
      size: PAGE_SIZE,
      isSuggested: true,
    };

    fetchApi(HTTP_METHODS.GET, RESOURCES, null, params)
      .then(res => {
        if (res.status == 200) {
          setRecommendedResources(res.data.data.rows);
        }
        // lpc.setVisible(false);
      })
      .catch(e => {
        // Dlog(e);
        // lpc.setVisible(false);
        esc.showError(e);
      });
  };

  return (
    <RecomendedResourcesList
      data={recommendedResources}
      refreshMainList={getRecommendedResources}
      title={title} //"From Us To You"
      isSeeAll={isSeeAll}
    />
  );
}
